<template>
  <div id="removeclass">
    <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="addurl"
        >
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <label>{{ $t("forms") }}</label>
                <app-input
                  type="multi-select"
                  :isAnimatedDropdown="true"
                  :placeholder="$t('forms')"
                  :list="this.forms"
                  v-model="inputs.form_id"
                />
                <p v-if="refreshShow == false" class="font-italic text-muted">
                  {{ $t("shortcut_form_create") }} <span><a href="#" @click.prevent="createForm()">{{$t("create_new")}}</a></span>
                </p>
                <p v-if="refreshShow == true" class="font-italic text-muted">
                  <a href="#" @click.prevent="refreshForm()">{{$t("refresh")}}</a><span> {{ $t("form_create_refresh") }}</span>
                </p>
              </div>
            </div>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { axiosPost, axiosGet } from "../../../../Helpers/AxiosHelper";
import AppLibrary from "../../../../Helpers/AppLibrary";
import { SELECT_PUBLIC_FORM, SELECTED_FORM_STORE} from "../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  extends:AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      refreshShow: false,
      addurl: SELECTED_FORM_STORE,
      preloader: false,
      inputs: {},
      forms: [],
      modalId: "select-form-modal",
      modalTitle: this.$t("select_form"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      let formData = new FormData();
      Object.keys(this.inputs).forEach((key) => {
        formData.append(key,this.inputs[key]);
      });
      this.save(formData);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
    getForms() {
      axiosGet(SELECT_PUBLIC_FORM)
        .then((res) => {
          this.forms = res.data;
        })
        .catch((error) => {
          
        });
    },
    refreshForm() {
      this.refreshShow = false;
      this.getForms();

    },
    createForm() {
      this.refreshShow = true;
      window.open('/admin/documentlibrary/mydocument', '_blank');
    },
  },
  mounted() {
    this.getForms();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
